import { UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './recommendationsSection.css';

interface IRecommendationsSection {
  title: string;
  watchAll: React.ReactElement;
}

export const RecommendationsSection = ({
  title,
  children,
  watchAll,
}: React.PropsWithChildren<IRecommendationsSection>) => {
  return (
    <section
      id="newbuilding-recommendations"
      data-testid="NewbuildingRecommendations"
      data-name="NewbuildingRecommendations"
      className={styles['section']}
    >
      <div className={styles['header']}>
        <UIHeading2>{title}</UIHeading2>
      </div>
      <div className={styles['recommendations']}>{children}</div>
      <div className={styles['action']}>{watchAll}</div>
    </section>
  );
};
